
import { WizClassifySelect, WizClassifySelectRe } from '@/containers/common';
import React from "react";

const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "type",
      searchItem: {
        type: "hidden",
      },
      formItem: {
        type: "hidden",
      } 
    },
    {
      name: "typeInfos",
      searchItem: {
        type: "hidden",
      },
      formItem: {
        type: "hidden",
      }
    },
    
    {
      name: "createBy",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "createTime",
      formItem: {
        type: "hidden",
      }
    },
    
    {
        title: "标签分类",
        name: "typeIds",
        dataIndex: "typeIds",
        searchItem: {
          type: 'diy',
          diy: WizClassifySelect,
          returnKey: true,
          wizTreeSelectListProps: {
  
            itemProps: {
              icon: 'unordered-list',
              title: '标签分类',
              tips: '请勾选所属标签分类'
            },
            treeProps: { checkStrictly: true }
          },
          apiProps: { type: 6 },
          selectProps: {
            placeholder: '请选择标签分类'
          },
        },

        formItem: {
            type: 'diy',
           
            diy: WizClassifySelectRe,
            returnKey: true,
            wizTreeSelectListProps: {
                checkable:false,
              itemProps: {
                icon: 'unordered-list',
                title: '标签分类',
                tips: '请勾选所属标签分类'
              },
              treeProps: { checkStrictly: true }
            },
            apiProps: { type: 6 },
            selectProps: {
              placeholder: '请选择标签分类'
            },
            links:['typeInfos'],
            changePopsFunction: (
              linksValues
            ) => {
              const { typeInfos } = linksValues
              let initSelects = []
              if(typeInfos && typeInfos instanceof Array &&typeInfos.length>0){
                typeInfos.forEach(element => {    
                    initSelects.push(element)
                });
                
              }
              //return { initSelects:initSelects }
              return { initSelects:initSelects }
            },
            initSelects:[],
            //onClearWiz: this._onClearWiz.bind(this),
            rules: [
                { required: true, message: '请选择标签分类', type: 'array' },
            ],
  
          },
      },
    {
      title: "标签名称",
      name: "title",
      dataIndex: "title",
      formItem: {
        maxlength: 10,
        placeholder: '标签名称最多输入10个字',
        rules: [
          {
            required: true,
            message: '请输入标签名称'
          },
          {
            pattern: /^[^\s]*$/,
            message: '标签名称录入信息不能包含空格'
          }
        ],
      },
      searchItem: {},
      tableItem: {
        width: 150
      }
    },
    {
      title: "分类名称",
      name: "categoryName",
      dataIndex: "categoryName",
      tableItem: {
        width: 150
      }
    },
    {
      title: "标签说明",
      name: "intro",
      dataIndex: "intro",
      tableItem: {
        width: 260,
      },
      formItem: {
        type: 'textarea',
        placeholder: '请输入标签说明,最多100字',
        rules: [
          {
            required: true,
            message: '请输入标签说明'
          },
        ],
        maxlength: 100,
      },
    },
    {
      title: "顺序",
      name: "orderNo",
      dataIndex: "orderNo",
      tableItem: {
        width: 80,
      },
      formItem: {
        type: 'number',
         // initialValue: data.orderNo,
        rules: [{
          required: true,
          message: '请输入顺序',
        }],
      }
    },
    {
      title: "标签热度值",
      name: "hotValue",
      dataIndex: "hotValue",
      tableItem: {
        width: 120,
        type: 'number',
         // initialValue: data.hotValue,
        rules: [{
          required: true,
          message: '请输入标签热度值',
        }],
    },
      formItem: {
        type: 'number',
      }
    },
]
}

const tableApi = (api = {}) => {
  return {
    path: 'contentLabel/listByPage',
    ...api
  }
}

const label = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(),
    tableApi: tableApi(api)
  }
}

export default label